'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _lookme_app_icon = require('assets/img/common/lookme_app_icon.png');

var _lookme_app_icon2 = _interopRequireDefault(_lookme_app_icon);

var _close_black = require('assets/img/common/close_black.png');

var _close_black2 = _interopRequireDefault(_close_black);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderBanner = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appLink: state.setup.appLink,
    shop: state.shops.shop,
    configHeader: state.setup.configHeader
  };
}, (0, _extends3.default)({}, setupActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HeaderBanner, _Component);

  function HeaderBanner(props) {
    (0, _classCallCheck3.default)(this, HeaderBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HeaderBanner.__proto__ || (0, _getPrototypeOf2.default)(HeaderBanner)).call(this, props));

    _this.state = {
      showBanner: true
    };

    _this.onCloseBanner = function () {
      _this.props.closeBanner();
    };

    return _this;
  }

  (0, _createClass3.default)(HeaderBanner, [{
    key: 'loadDynamicLink',
    value: function loadDynamicLink(props) {
      switch (props.configHeader.page) {
        case 'ShopDetail':
          props.loadDynamicLink('shop', props.handle);
          break;
        case 'ExchangeReward':
          props.loadDynamicLink('voucher', props.handle);
          break;
        case 'CollectionDetail':
          props.loadDynamicLink('collection', props.handle);
          break;
        default:
          if (props.pathname === '/') {
            props.loadDynamicLink('page', props.pathname);
          } else {
            props.loadDynamicLink('page', props.pathname.replace('/', '').split('?')[0]);
          }
          break;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.handle !== nextProps.handle || this.props.pathname !== nextProps.pathname) {
        this.loadDynamicLink(nextProps);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.pathname) {
        this.loadDynamicLink(this.props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./HeaderBanner.scss');
      var appLink = this.props.appLink;

      return _react2.default.createElement(
        'div',
        { className: styles.bigview, ref: function ref(elem) {
            return _this2.nv = elem;
          } },
        _react2.default.createElement(
          'div',
          {
            className: styles.banner,
            style: { marginTop: !this.props.showBanner ? '-43px' : 0 }
          },
          _react2.default.createElement(
            'div',
            { className: styles.logoDiv },
            _react2.default.createElement('img', { className: styles.logoImg, src: _lookme_app_icon2.default })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.divFlexEnd },
            _react2.default.createElement(
              'div',
              { className: styles.textBanner },
              _react2.default.createElement(
                'div',
                { className: styles.textTop },
                'LOOKME - \u0110\u1EB7t l\u1ECBch l\xE0m \u0111\u1EB9p'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.textBottom },
                'V\u1EDBi nhi\u1EC1u \u01B0u \u0111\xE3i h\u1EA5p d\u1EABn h\u01A1n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.finalFlex },
              _react2.default.createElement(
                'div',
                { className: styles.openButtonDiv },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    className: styles.openButton,
                    to: appLink,
                    target: '_blank'
                  },
                  'M\u1EDE APP'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.closeBanner },
                _react2.default.createElement('img', {
                  className: styles.closeIcon,
                  onClick: this.onCloseBanner,
                  src: _close_black2.default
                })
              )
            )
          )
        )
      );
    }
  }]);
  return HeaderBanner;
}(_react.Component), _class2.propTypes = {
  appLink: _react.PropTypes.string,
  handle: _react.PropTypes.string,
  pathname: _react.PropTypes.string,
  configHeader: _react.PropTypes.object,
  closeBanner: _react.PropTypes.func,
  showBanner: _react.PropTypes.bool,
  loadDynamicLink: _react.PropTypes.func
}, _temp)) || _class);
exports.default = HeaderBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HeaderBanner.js
// module id = 1576
// module chunks = 0